import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import hash from 'object-hash';
import { useQuery } from 'react-query';
import { apigatewayBaseRoute as baseURL } from 'services/restApiConst';

export interface GetApprovalContactsParams {
  fleet_id: string;
  amount: number;
}

export interface ApprovalContactResponse {
  first_name: string;
  last_name: string;
  email_address: string;
  cell_phone?: string | null;
}

const getApprovalContacts: MaestroAPI = { method: 'POST', endpoint: 'approvalLimits/findContacts', baseURL };

export function useGetApprovalContacts(payload: GetApprovalContactsParams | null) {
  return useQuery<ApprovalContactResponse[] | null>(
    ['get-contacts', hash(payload)],
    () => {
      if (payload) return maestroApiCall(getApprovalContacts, payload);
      return null;
    },
    {
      cacheTime: 3600,
    },
  );
}
